import { render, staticRenderFns } from "./dataList.vue?vue&type=template&id=5bfd319b&scoped=true&"
import script from "./dataList.vue?vue&type=script&lang=js&"
export * from "./dataList.vue?vue&type=script&lang=js&"
import style0 from "./dataList.vue?vue&type=style&index=0&id=5bfd319b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd319b",
  null
  
)

export default component.exports